import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleAuthCallback } from '../../redux/slices/authSlice';
import { useNavigate } from "react-router-dom";
import { ThunkDispatch, Action } from "@reduxjs/toolkit";
import { RootState } from "../../redux/rootReducer";

const AuthCallback: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>();
  const navigate = useNavigate();

  useEffect(() => {
    const processCallback = async () => {
      await dispatch(handleAuthCallback()); // Properly dispatches the async thunk
      navigate("/"); // Redirect after authentication
    };

    processCallback();
  }, [dispatch, navigate]);

  return <div>Processing authentication...</div>;
};

export default AuthCallback;